import {
  USER_PRODUCTIVITY_REQUEST,
  USER_PRODUCTIVITY_SUCCESS,
  USER_PRODUCTIVITY_FAIL,
  USER_MONTH_PRODUCTIVITY_REQUEST,
  USER_MONTH_PRODUCTIVITY_SUCCESS,
  USER_MONTH_PRODUCTIVITY_FAIL,
  USER_PREV_PRODUCTIVITY_FAIL,
  USER_PREV_PRODUCTIVITY_REQUEST,
  USER_PREV_PRODUCTIVITY_SUCCESS,
} from '../../types/user/productiveTypes';

export const userProductReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PRODUCTIVITY_REQUEST:
      return {
        ...state,
        userLoading: true,
      };
    case USER_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        userLoading: false,
        productiveList: payload,
        userError: '',
      };
    case USER_PRODUCTIVITY_FAIL:
      return {
        ...state,
        userLoading: false,
        userError: payload,
        productiveList: [],
      };
    default:
      return state;
  }
};

export const userPrevProductReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PREV_PRODUCTIVITY_REQUEST:
      return {
        ...state,
        prevProLoading: true,
      };
    case USER_PREV_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        prevProLoading: false,
        productivePrevList: payload,
        prevProError: '',
      };
    case USER_PREV_PRODUCTIVITY_FAIL:
      return {
        ...state,
        prevProLoading: false,
        prevProError: payload,
        productivePrevList: [],
      };
    default:
      return state;
  }
};

export const userMonthProductReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_MONTH_PRODUCTIVITY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_MONTH_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        productMonthList: payload,
        error: '',
      };
    case USER_MONTH_PRODUCTIVITY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        productMonthList: [],
      };
    default:
      return state;
  }
};
